import FrameComponent2 from "./FrameComponent2";
import PropTypes from "prop-types";

const FrameComponent3 = ({ className = "" }) => {
  return (
    <section
      className={`flex-1 flex flex-col items-end gap-[116px] min-w-[425px] max-w-full text-center text-[40px] text-[#fff] font-['Great_Vibes'] mq750:gap-[58px] mq750:min-w-full mq450:gap-[29px] ${className}`}
    >
      <div className="w-[424px] flex items-start justify-center pt-0 px-5 pb-[30.9px] box-border max-w-full">
        <FrameComponent2 />
      </div>
      <div className="self-stretch flex flex-col items-start gap-[48.9px] max-w-full text-left text-4xl text-schemes-primary font-[Manrope] mq750:gap-6">
        <div className="flex flex-col items-start gap-[22.1px] max-w-full shrink-0">
          <div className="h-[47px] relative font-extrabold inline-block max-w-full mq750:text-[29px] mq450:text-[22px]">
            <span>Less</span>
            <span className="text-5xl">{` `}</span>
            <span className="text-[64px]">Edtech.</span>
          </div>
          <div className="h-12 relative font-extrabold inline-block mq750:text-[29px] mq450:text-[22px]">
            <span>More</span>
            <span className="text-[40px]">{` `}</span>
            <span className="text-[64px]">Education.</span>
          </div>
        </div>
        <h1 className="m-0 h-11 relative text-[32px] font-normal font-[inherit] text-[#000] inline-block mq750:text-[26px] mq450:text-[19px]">
          Less technology noise. More teaching clarity
        </h1>
      </div>
      <div className="self-stretch flex items-start justify-center py-0 pl-5 pr-[182px] mq450:pr-5 mq450:box-border">
        <div className="flex flex-col items-end gap-11">
          <div className="flex items-start gap-4">
            <button className="cursor-pointer [border:none] p-0 bg-[#fff] h-[25px] w-[25px] relative rounded-[50%]" />
            <button className="cursor-pointer [border:none] p-0 bg-[#fff] h-[25px] w-[25px] relative rounded-[50%]" />
            <button className="cursor-pointer [border:none] p-0 bg-[#353434] h-[25px] w-[25px] relative rounded-[50%]" />
            <button className="cursor-pointer [border:none] p-0 bg-[#fff] h-[25px] w-[25px] relative rounded-[50%]" />
            <button className="cursor-pointer [border:none] p-0 bg-[#fff] h-[25px] w-[25px] relative rounded-[50%]" />
            <button className="cursor-pointer [border:none] p-0 bg-[#fff] h-[25px] w-[25px] relative rounded-[50%]" />
          </div>
          <div className="flex items-start justify-end py-0 pl-6 pr-[23px]">
            <button className="cursor-pointer border-[#948d8d] border-solid border-[1px] pt-3.5 pb-4 pl-[29px] pr-6 bg-[#fff] h-[67px] rounded-[5px] box-border flex items-start hover:bg-[#e6e6e6] hover:border-[#7a7373] hover:border-solid hover:hover:border-[1px] hover:box-border">
              <div className="h-[67px] w-[183px] relative rounded-[5px] bg-[#fff] border-[#948d8d] border-solid border-[1px] box-border hidden shrink-0" />
              <div className="relative text-2xl font-[Manrope] text-[#000] text-left z-[1] shrink-0">
                Get Started
              </div>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

FrameComponent3.propTypes = {
  className: PropTypes.string,
};

export default FrameComponent3;
